import { environment } from "src/environments/environment";

export namespace ZendeskArticleModel {
	export interface ZendeskArticleRaw {
		id: number;
		url: string;
		html_url: string;
		author_id: number;
		comments_disabled: boolean,
		draft: boolean,
		promoted: boolean,
		position: number,
		vote_sum: number,
		vote_count: number,
		section_id?: number;
		created_at?: string;
		updated_at?: string;
		name?: string;
		title?: string;
		source_locale: string;
		locale?: string;
		outdated: boolean,
		outdated_locales: string[],
		edited_at: string,
		user_segment_id: number,
		permission_group_id: number,
		content_tag_ids: number[],
		label_names?: string[];
		body?: string;
	}

	export interface ZendeskArticlesResponse {
		count: number;
		page?: number;
		per_page?: number;
		page_count?: number;
		next_page?: string | null;
		previous_page?: string | null;
		articles: ZendeskArticleRaw[];
	}

	export interface ArticleItem {
		id: number;
		title: string;
		htmlUrl: string;
		bodyHtml: string;
		createdAt?: string;
		updatedAt?: string;
		category?: string; // derived from labels
		youtubeIds: string[]; // extracted YouTube video IDs
		youtubeEmbedUrls: string[]; // pre-computed YouTube embed URLs
	}

	export function extractYoutubeIds(html: string): string[] {
		if (!html) return [];
		const ids = new Set<string>();
		const patterns = [/(?:v=|\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{11})/g];
		for (const re of patterns) {
			let m: RegExpExecArray | null;
			while ((m = re.exec(html)) !== null) {
				ids.add(m[1]);
			}
		}
		return [...ids];
	}

	export function stripYoutubeLinks(html: string): string {
		if (!html) return '';
		// Remove YouTube anchor tags
		html = html.replace(/<a[^>]+href=["']https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)[^"']*["'][^>]*>.*?<\/a>/gi, '');
		// Remove plain YouTube URLs
		html = html.replace(/https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\S+/gi, '');
		return html;
	}

	export function proxyImageUrls(html: string): string {
		if (!html) return '';

		const supportApiUrl =
			environment.env === 'localNoKube' ||
				environment.env === 'localNoKubeStaging' ||
				environment.env === 'localNoKubeProd'
				? 'http://127.0.0.1:3031'
				: environment.apiLumana;

		const apiUrl = `${supportApiUrl}/support/zendesk/articles`;

		// Match Zendesk attachment URLs
		// Pattern: https://support.lumana.ai/hc/article_attachments/{attachmentId}
		const zendeskPattern = /https:\/\/[^\/]+\.zendesk\.com\/hc\/article_attachments\/(\d+)/gi;

		html = html.replace(zendeskPattern, (match, attachmentId) => {
			return `${apiUrl}/article-attachments/${attachmentId}`;
		});

		return html;
	}
}

